import React, { useEffect, useRef, useState } from "react";

import { Pill } from "@at/design-system-elements";

import {
  GalleryFilterPillContainerToolbar,
  GalleryFilterPillFlexWrapper,
} from "./gallery-category-pills-toolbar.styled";

export interface IGalleryCategoryPillsToolbarProps {
  categories: string[];
  activeCategory: string;
  hasMultipleMediaTypes: boolean;
  handleCategoryChange: (category: string) => void;
}

export const GalleryCategoryPillsToolbar = ({
  categories,
  activeCategory,
  hasMultipleMediaTypes,
  handleCategoryChange,
}: IGalleryCategoryPillsToolbarProps) => {
  const [isSticky, setIsSticky] = useState(true);
  const toolbarRef = useRef<HTMLElement>(null);
  const lastScrollTopRef = useRef(0);

  useEffect(() => {
    const scrollableElement = toolbarRef.current?.parentElement;

    const handleScroll = () => {
      if (scrollableElement) {
        const currentScrollY = scrollableElement.scrollTop;
        const lastScrollY = lastScrollTopRef.current;
        setIsSticky(currentScrollY > lastScrollY ? false : true);
        lastScrollTopRef.current = currentScrollY;
      }
    };

    scrollableElement?.addEventListener("scroll", handleScroll);

    return () => {
      scrollableElement?.removeEventListener("scroll", handleScroll);
    };
  }, [toolbarRef]);

  return (
    <GalleryFilterPillContainerToolbar
      ref={toolbarRef}
      isSticky={isSticky}
      hasMultipleMediaTypes={hasMultipleMediaTypes}
      aria-label="Filter images by category"
    >
      <GalleryFilterPillFlexWrapper>
        {categories.map((category) => (
          <Pill
            key={category}
            displayType="category"
            onClick={() => handleCategoryChange(category)}
            isActive={activeCategory === category}
            text={category}
            aria-pressed={activeCategory === category}
            aria-label={`Filter by ${category}`}
          />
        ))}
      </GalleryFilterPillFlexWrapper>
    </GalleryFilterPillContainerToolbar>
  );
};
